/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';

import { ElButtonComponent } from './button.component';

const EL_BUTTON_COMPONENTS = [
  ElButtonComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
  ],
  declarations: [
    ...EL_BUTTON_COMPONENTS,
  ],
  exports: [
    ...EL_BUTTON_COMPONENTS,
  ],
})
export class ElButtonModule { }
